import styles from "./PaymentTitle.module.scss";

interface PaymentTitleProps {
  children: React.ReactNode;
}

const PaymentTitle = ({ children }: PaymentTitleProps) => {
  return <h1 className={styles.title}>{children}</h1>;
};

export default PaymentTitle;
